export const LAST_ACTIVITY_KEY = 'last_activity_at';

/** Log out after 15 minutes without user interaction. */
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;

const isBrowser = () => typeof window !== 'undefined';

export const touchSessionActivity = () => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  } catch {
    // ignore storage errors
  }
};

export const getLastActivityAt = () => {
  if (!isBrowser()) return Date.now();
  try {
    const raw = window.localStorage.getItem(LAST_ACTIVITY_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : Date.now();
  } catch {
    return Date.now();
  }
};

export const getIdleDurationMs = () => Date.now() - getLastActivityAt();

export const isSessionIdle = (timeoutMs = IDLE_TIMEOUT_MS) =>
  getIdleDurationMs() >= timeoutMs;

export const clearSessionActivity = () => {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    // ignore storage errors
  }
};
